/* eslint-disable camelcase */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type Volo_Abp_AspNetCore_Mvc_ApplicationConfigurations_ApplicationConfigurationDto } from '@wealthlane/api-services/wealthlane-customer-service';
import type { RootState } from '../../store/store';
import { FeatureSet } from '../../utils/permission/permissionAdapter';
import { OptionDto_Guid } from '@wealthlane/api-services/wealthlane-identity-service';

interface RouteState {
  currentUserRoutesList: any[];
  currentUserAuthList: Volo_Abp_AspNetCore_Mvc_ApplicationConfigurations_ApplicationConfigurationDto;
  featureSetList: OptionDto_Guid[];
}

const initialState: RouteState = {
  currentUserRoutesList: [],
  currentUserAuthList: {},
  featureSetList: [],
};

const slice = createSlice({
  name: 'routes',
  initialState,
  reducers: {
    setRouteList: (
      state,
      {
        payload: { currentUserRoutesList, currentUserAuthList },
      }: PayloadAction<{
        currentUserRoutesList: any[];
        currentUserAuthList: any;
      }>
    ) => {
      state.currentUserAuthList = currentUserAuthList;
      state.currentUserRoutesList = currentUserRoutesList;
    },
    setFeatureSetList: (
      state,
      {
        payload: { featureSetList },
      }: PayloadAction<{
        featureSetList: OptionDto_Guid[];
      }>
    ) => {
      state.featureSetList = featureSetList;
    },
  },
});

export const { setRouteList, setFeatureSetList } = slice.actions;

export default slice.reducer;

export const selectAuthRoutesList = (state: RootState): any => state?.route.currentUserAuthList;

export const selectUserRoutesList = (state: RootState): any => state?.route.currentUserRoutesList;
